interface NoDoublesLogoProps {
  variant?: 'white' | 'green';
  className?: string;
  size?: number;
}

/**
 * No Doubles Logo - Script logo with swoosh
 * @param variant - 'white' for dark backgrounds, 'green' for light backgrounds
 * @param size - Height in pixels (width auto-scales)
 * @param className - Additional Tailwind classes
 */
export default function NoDoublesLogo({ variant = 'white', className = '', size }: NoDoublesLogoProps) {
  const logoSrc = variant === 'white' ? '/nodoubles_logo_trans.png' : '/nodoubles_logo_green.png';
  const sizeStyle = size ? { height: `${size}px`, width: 'auto' } : {};
  
  return (
    <img
      src={logoSrc}
      alt="No Doubles Golf Co"
      className={className}
      style={sizeStyle}
    />
  );
}

